import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface Iprops {
  loading?: boolean;
  oppacity?: number;
}

const FullPageLoading = ({ loading, oppacity = 0.6 }: Iprops) => {
  return (
    <div className={`full-loading-warper ${loading ? 'active' : ''}`}>
      <div className="loading-background" style={{ opacity: oppacity }}></div>
      <div className="spin">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
      </div>
    </div>
  );
};
export default FullPageLoading;
